import React from 'react'
import { Dropdown } from 'react-bootstrap'

function CustomDropdown({ onDropDownValueChange }) {
  const dropDownList = ['COMMON', 'RARE', 'ULTRA_RARE', 'LEGENDARY'/*, 'MYTHIC'*/]

  const onSelectChange = (e) => {
    onDropDownValueChange(dropDownList.indexOf(e.target.value))
  }

  return (
    <>
      <label className="w-full my-2 font-serif text-white" id="rarity">
        Select the rarity type from here:
      </label>
      <select
        onChange={onSelectChange}
        className="font-serif bg-gray-300  border-gray-300  text-sm rounded-lg  block w-full p-2.5 dark:bg-grey text-black dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
        name="rarity"
        id="rarity"
        defaultValue={'COMMON'}
      >
        {dropDownList.map((item, i) => (
          <option key={i} value={item}>
            {item}
          </option>
        ))}
        {/* <option value="" hidden>
          Choose the Rarity from here
        </option> */}
      </select>
    </>
  )
}

export default CustomDropdown
